// extracted by mini-css-extract-plugin
export default {"notepad":"style_notepad__kbtQp","title":"style_title__Dss+S","textList":"style_textList__987G-"};